import { AppointmentStatus } from "../../../../Constants";
import { EndPoints } from "../../../../Constants/endpoints";
import { useGetData } from "../../../../hooks";
import { IAppointmentStatus } from "../../../../interface/appointmentInterfaces";
 
 

interface IAppointmentStatusTag {
  statusCode?: string;
}
const AppointmentStatusTag: React.FC<IAppointmentStatusTag> = ({
  statusCode,
}) => {
  const { data: statusesData } = useGetData<IAppointmentStatus[]>(
    EndPoints.AppointmentStatuses,
  );
  const appointmentStatuses = statusesData?.Data;

  const statusObject = appointmentStatuses?.find(
    (status: IAppointmentStatus) => statusCode == status?.Code,
  );

  const statusClasses =
    statusObject?.Code == AppointmentStatus.Approved ||
    statusObject?.Code == AppointmentStatus.Done
      ? "text-positive border-positive bg-positive-00"
      : statusObject?.Code == AppointmentStatus.Pending
        ? "text-orange border-orange bg-orange-00"
        : "text-error border-error  bg-error-00";
  return (
    <span
      className={`w-fit cursor-default text-nowrap rounded-full border px-2 py-0.5 text-xs font-bold ${statusClasses}`}
    >
      {statusObject?.Name}
    </span>
  );
};

export default AppointmentStatusTag;
